// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__b1cjT","notes":"Notes_notes__1gdmI","note":"Notes_note__ZEJfj","markdown":"Notes_markdown__3NNZk"};